export default function Markdown({ text }) {
  if (!text) return null;
  const lines = text.split("\n");
  const blocks = [];
  let list = [];
  const flush = (i) => {
    if (list.length) {
      blocks.push(<ul key={`ul-${i}`} className="list-disc pl-5 space-y-1 my-2">{list}</ul>);
      list = [];
    }
  };
  const inline = (s) =>
    s.split(/(\*\*[^*]+\*\*)/g).map((p, j) =>
      p.startsWith("**") && p.endsWith("**") ? <strong key={j}>{p.slice(2, -2)}</strong> : p
    );

  lines.forEach((raw, i) => {
    const line = raw.trimEnd();
    if (line.startsWith("### ")) { flush(i); blocks.push(<h4 key={i} className="font-display font-bold text-base mt-4 mb-1">{inline(line.slice(4))}</h4>); }
    else if (line.startsWith("## ")) { flush(i); blocks.push(<h3 key={i} className="font-display font-bold text-lg mt-5 mb-2">{inline(line.slice(3))}</h3>); }
    else if (line.startsWith("# ")) { flush(i); blocks.push(<h2 key={i} className="font-display font-extrabold text-xl mt-5 mb-2">{inline(line.slice(2))}</h2>); }
    else if (/^\s*[-*]\s+/.test(line)) {
      const body = line.replace(/^\s*[-*]\s+/, "");
      const m = body.match(/^\[( |x|X)\]\s*(.*)$/);
      if (m) list.push(<li key={i} className="text-sm list-none -ml-5 flex items-start gap-1.5" data-testid="md-task-item"><span className="select-none text-base leading-5">{m[1].toLowerCase() === "x" ? "☑" : "☐"}</span><span>{inline(m[2])}</span></li>);
      else list.push(<li key={i} className="text-sm">{inline(body)}</li>);
    }
    else if (line.trim() === "") { flush(i); }
    else { flush(i); blocks.push(<p key={i} className="text-sm my-1.5 leading-relaxed">{inline(line)}</p>); }
  });
  flush("end");
  return <div data-testid="markdown-content">{blocks}</div>;
}
